<template>
  <div class="Copyright">
    <div v-if="copyright.bottom_declare && copyright.bottom_declare.indexOf('by') !== -1">
      {{
        copyright.bottom_declare.substr(
          0,
          copyright.bottom_declare.indexOf("by")
        )
      }}
      <br />
      {{
        copyright.bottom_declare.substr(
          copyright.bottom_declare.indexOf("by"),
          copyright.bottom_declare.length
        )
      }}
    </div>
    <div v-else>
      {{copyright.bottom_declare}}
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  name: "compFoot",
  computed: {
    ...mapState({
      copyright: (state) => state.website.copyright,
    }),
  },
  methods: {
    async getCopyright(lottery_id) {
      await this.$store.dispatch("website/getCopyright");
    },
  },
  async mounted() {
    await this.getCopyright();
  },
};
</script>
